import React from "react";
import { Card, CardBody, Col, Container, Form, Row } from "reactstrap";
import { BaseButton, BaseInput } from "Components/ui";
import { useFormik } from "formik";
import { SupplierValidationSchema } from "utils";
import { useCreateSupplier } from "hooks/useSuppliers";
import { toast } from "react-toastify";
import Breadcrumbs from "../../Components/Common/Breadcrumb";
import { useNavigate } from "react-router-dom";
import { AppRoutes } from "../../constants";

const AddSupplier = () => {
  document.title = "Papermap | Add a new Supplier";
  const { mutate, isPending } = useCreateSupplier();
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: {
      name: "",
      phone: "",
      email: "",
      address: "",
      notes: "",
    },
    validationSchema: SupplierValidationSchema,
    onSubmit: async (values) => {
      mutate(
        {
          name: values.name,
          phone: values.phone,
          email: values.email,
          address: values.address,
          notes: values.notes,
        },
        {
          onSuccess: () => {
            navigate(AppRoutes.SUPPLIERS);
            toast.success("Supplier created successfully.");
            formik.resetForm();
          },
          onError: (error) => {
            toast.error("Failed to create supplier.");
          },
        }
      );
    },
  });

  const handleCancel = () => {
    navigate(AppRoutes.SUPPLIERS);
  };

  return (
    <React.Fragment>
      <div className={`page-content`}>
        <Container fluid>
          {/* Breadcrumb */}
          <Breadcrumbs title="Suppliers" breadcrumbItem="Add Supplier" />

          <Form onSubmit={formik.handleSubmit} autoComplete="off">
            <Row>
              <Col xs={12}>
                {/* Basic Information */}

                <Card>
                  <CardBody>
                    <Form onSubmit={formik.handleSubmit} autoComplete="off">
                      <Row>
                        <Col sm="12">
                          <div className="mb-3">
                            <BaseInput
                              label="Name*"
                              name="name"
                              type="text"
                              value={formik.values.name}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              invalid={
                                formik.touched.name && !!formik.errors.name
                              }
                              errorMessage={formik.errors.name}
                            />
                          </div>
                        </Col>
                        <Col sm="6">
                          <div className="mb-3">
                            <BaseInput
                              label="Phone"
                              name="phone"
                              type="text"
                              value={formik.values.phone}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              invalid={
                                formik.touched.phone && !!formik.errors.phone
                              }
                              errorMessage={formik.errors.phone}
                            />
                          </div>
                        </Col>
                        <Col sm="6">
                          <div className="mb-3">
                            <BaseInput
                              label="Email"
                              name="email"
                              type="email"
                              value={formik.values.email}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              invalid={
                                formik.touched.email && !!formik.errors.email
                              }
                              errorMessage={formik.errors.email}
                            />
                          </div>
                        </Col>
                        <Col sm="6">
                          <div className="mb-3">
                            <BaseInput
                              label="Address"
                              name="address"
                              type="textarea"
                              value={formik.values.address}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              invalid={
                                formik.touched.address &&
                                !!formik.errors.address
                              }
                              errorMessage={formik.errors.address}
                            />
                          </div>
                        </Col>
                        <Col sm="6">
                          <div className="mb-3">
                            <BaseInput
                              label="Notes"
                              name="notes"
                              type="textarea"
                              value={formik.values.notes}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              invalid={
                                formik.touched.notes && !!formik.errors.notes
                              }
                              errorMessage={formik.errors.notes}
                            />
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            {/* Button Section */}
            <div className="d-flex justify-content-end mt-3">
              <BaseButton
                type="submit"
                color="primary"
                className="w-20 me-1"
                style={{ width: "20%" }}
                loading={isPending}
              >
                Submit
              </BaseButton>
              <BaseButton
                color="secondary"
                className="w-20 ms-1"
                style={{ width: "20%" }}
                onClick={handleCancel} // Handle cancel action
              >
                Cancel
              </BaseButton>
            </div>
          </Form>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default AddSupplier;
